import React, { MouseEventHandler } from 'react';
import close from '../../icons/close_large.svg';
import { Icon } from './Icon';

interface CloseIconProps {
  onClick: MouseEventHandler;
  className?: string;
}

/**Close Icon for modals, dialogs, etc */
export function CloseIcon({ onClick, className }: CloseIconProps) {
  return (
    <Icon
      data-cy="closeIcon"
      onClick={onClick}
      glyph={close}
      sx={{
        cursor: 'pointer'
      }}
      className={className}
    />
  );
}
